import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Grid, Button } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Locations',
      description: 'Manage locations and their hierarchies',
      path: '/locations'
    },
    {
      title: 'Users',
      description: 'View and manage user accounts',
      path: '/users'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.title} disablePadding>
                <ListItemButton onClick={() => navigate(item.path)}>
                  <ListItemText 
                    primary={item.title}
                    secondary={item.description}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>

      <Button component={Link} to="/grid-icon-export" variant="contained" sx={{ mt: 2 }}>
        GridIcon Exporter
      </Button>
    </Box>
  );
};

export default Dashboard; 